import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTechnologyList,
  fetchTechnologyCheckList,
  updatedTechnologyList,
  deleteTechnologyList,
} from "./TechnologyActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practiceTechnologyList = createSlice({
  name: "practiceTechnologyList",
  initialState: {
    isTechnologyLoading: false,
    technologyData: [],
    technologyErrorMsg: "",
    technologyError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTechnologyList.pending, (state) => {
        state.isTechnologyLoading = true;
        state.technologyError = null;
      })
      .addCase(fetchTechnologyList.fulfilled, (state, action) => {
        state.isTechnologyLoading = false;
        if (!action.payload.success) {
          if (
            action.payload.data.metadata?.outcome.additionalDetails[0]
              ?.additionalInfo
          ) {
            state.technologyError = false;
            state.technologyData = [];
            state.isTechnologyLoading = false;
          } else {
            state.technologyError = true;
            state.technologyErrorMsg = getApiErrorMessage(
              action.payload.status
            );
          }
        } else {
          state.technologyError = false;
          state.technologyData =
            action.payload.data.data.practiceTechnologyResponseDTO;
        }
      })
      .addCase(fetchTechnologyList.rejected, (state, action) => {
        state.isTechnologyLoading = false;
        state.technologyError = action.error.message;
      });
    builder
      .addCase(updatedTechnologyList.pending, (state) => {
        state.isTechnologyLoading = true;
        state.technologyError = null;
      })
      .addCase(updatedTechnologyList.fulfilled, (state, action) => {
        state.isTechnologyLoading = false;
        if (!action.payload.success) {
          state.isTechnologyLoading = false;
          state.technologyError = true;
          state.technologyErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.technologyError = false;
          state.technologyData =
            action.payload.data.data.practiceTechnologyResponseDTO;
        }
      })
      .addCase(updatedTechnologyList.rejected, (state, action) => {
        state.isTechnologyLoading = false;
        state.technologyError = action.error.message;
      });
    builder
      .addCase(deleteTechnologyList.pending, (state) => {
        state.isTechnologyLoading = true;
        state.technologyError = null;
      })
      .addCase(deleteTechnologyList.fulfilled, (state, action) => {
        state.isTechnologyLoading = false;
        if (!action.payload.success) {
          state.isTechnologyLoading = false;
          state.technologyError = true;
          state.technologyErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.isTechnologyLoading = false;
          state.technologyError = false;
        }
      })
      .addCase(deleteTechnologyList.rejected, (state, action) => {
        state.isTechnologyLoading = false;
        state.technologyError = action.error.message;
      });
  },
});

const practiceTechnologyCheckList = createSlice({
  name: "practiceTechnologyCheckList",
  initialState: {
    isTechnologyCheckLoading: false,
    technologyCheckData: [],
    technologyCheckErrorMsg: "",
    technologyCheckError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTechnologyCheckList.pending, (state) => {
        state.isTechnologyCheckLoading = true;
        state.technologyCheckError = null;
      })
      .addCase(fetchTechnologyCheckList.fulfilled, (state, action) => {
        state.isTechnologyCheckLoading = false;
        if(!action.payload.success){
            state.technologyCheckError = false;
            state.technologyCheckData = [];
            state.technologyCheckErrorMsg = getApiErrorMessage(action.payload.status);
        } else {
          state.technologyCheckError = false;
          state.technologyCheckData = action.payload.data.data.technologyDTO;
        }  
      })
      .addCase(fetchTechnologyCheckList.rejected, (state, action) => {
        state.isTechnologyCheckLoading = false;
        state.technologyCheckError = action.error.message;
      });
  },
});

export const practiceTechnologyListReducer = practiceTechnologyList.reducer;
export const practiceTechnologyCheckListReducer =
  practiceTechnologyCheckList.reducer;
